import React from "react";
import { connect } from "react-redux";
import "../css/homeHero.css";

const HomeHero = ({ hero }) => {
  if (!hero) return null; // prevents grey flash

  return (
    <div
      className="home-hero-container"
      style={{
        backgroundImage: hero.image_url
          ? `url(${hero.image_url})`
          : "none",
      }}
    >
      <div className="home-hero-inner">
        {/* LEFT SIDE */}
        <div className="home-hero-text">
          <h1 className="home-hero-heading">{hero.heading}</h1>
          <p className="home-hero-paragraph">{hero.paragraph}</p>
        </div>

        {/* RIGHT SIDE */}
        {hero.banner_image && (
          <div className="home-hero-image-wrapper">
            <img
              src={hero.banner_image}
              alt="Home Hero"
              className="home-hero-image"
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log("Redux state (full):", state);
return {
    hero: state.homeHero?.data || null,
  };
};

export default connect(mapStateToProps)(HomeHero);
